<section *ngIf="isLoading" class="loader-internal-main">
    <!--<h3>Loading Funding Options</h3>-->
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
</section>